<template>
  <div>
    <v-container></v-container>
  </div>
</template>

<script>
import { postMobileInfo } from '@/api/auth';
// import { getTokenFromCookie, getUserFromCookie } from '@/utils/auth/cookies';
import { callApp } from '@/utils/app/callApp.js';
import { mapGetters } from 'vuex';
import { checkAuth } from '@/utils/auth/authUtil';

export default {
  data() {
    return {
      test: 1,
    };
  },
  computed: {
    ...mapGetters(['GET_AUTH_TOKEN', 'GET_SESSION_TOKEN', 'GET_USER_KEY']),
  },
  methods: {
    /* 모바일 정보 서버 저장 */
    async saveMobileInfo(mobileInfo) {
      // console.log('AppResponse.vue saveMobileInfo');
      // console.log('================mobileInfo=================');
      // console.log('pushToken : ' + mobileInfo.pushToken);
      // console.log('deviceType : ' + mobileInfo.deviceType);
      // console.log('osVersion : ' + mobileInfo.osVersion);
      // console.log('deviceId : ' + mobileInfo.deviceId);
      // console.log('deviceModel : ' + mobileInfo.deviceModel);
      // console.log('appVersion : ' + mobileInfo.appVersion);
      // console.log('==========================================');
      try {
        await postMobileInfo({
          pushToken: mobileInfo.pushToken,
          deviceType: mobileInfo.deviceType,
          osVersion: mobileInfo.osVersion,
          deviceId: mobileInfo.deviceId,
          deviceModel: mobileInfo.deviceModel,
          appVersion: mobileInfo.appVersion,
        });
      } catch (error) {
        alert(error);
      }
    },

    /* 메인으로 이동 */
    toMain() {
      this.$store.commit('SPINNER/ON_COMMON_SPINNER');
      this.$router.replace('/main');
    },
  },
  created() {
    /** 앱 콜백 함수 선언 */

    /* 로그인 성공시 native -> web */
    window.afterSetSessionContext = async event => {
      try {
        const returnData = JSON.parse(event).afterSetSessionContext;
        const userData = returnData.contextData;
        // console.log('AppResponse afterSetSessionContext');
        // console.log('AppResponse userData : ' + JSON.stringify(userData));
        if (process.env.NODE_ENV === 'development') {
          this.$store.commit('setUserData', userData);
          this.$store.commit('setToken', userData);
        }

        this.$store.commit('setTokenObj', userData);
        await this.saveMobileInfo(returnData);
        this.toMain();
      } catch (error) {
        alert('#mobile - !error afterSetSessionContext ' + error);
      }
    };

    window.onLBSEvent = event => {
      const returnData = JSON.parse(event).onLBSEvent;
      if (returnData.eventType === 'in') {
        if (
          (returnData.isBeacon && returnData.beaconInfo !== null) ||
          (returnData.isGPS && returnData.gpsInfo.length !== null)
        ) {
          this.$store.commit('SET_LBS_FLAG', true);
        } else {
          this.$store.commit('SET_LBS_FLAG', false);
        }
      } else if (returnData.eventType === 'notin') {
        // notin 일경우 비활성화추가
        this.$store.commit('SET_LBS_FLAG', false);
      }
    };

    /*
     * native -> web 호출
     * app push token 만료 시 새 토큰으로 업데이트
     */
    window.updateAppPushToken = event => {
      try {
        const returnData = JSON.parse(event).updateAppPushToken;
        const userData = returnData.contextData;
        // console.log('AppResponse updateAppPushToken');
        // console.log('AppResponse userData : ' + JSON.stringify(userData));
        if (process.env.NODE_ENV === 'development') {
          this.$store.commit('setUserData', userData);
          this.$store.commit('setToken', userData);
        }

        this.$store.commit('setTokenObj', userData);
        this.saveMobileInfo(returnData);
      } catch (error) {
        alert('#mobile - !error updateAppPushToken ' + error);
      }
    };
  },

  mounted() {
    const appResType = this.$route.params.type;
    // console.log('AppResponse appResType : ' + appResType);
    if (appResType !== 'login') {
      const result = checkAuth();
      if (result) this.toMain();
    }

    // LBS call
    callApp.invalidateLocation();
  },
};
</script>

<style></style>
